// extracted by mini-css-extract-plugin
export var active = "_hu-2";
export var recordingDot = "_hu-1";
export var recordingIndicator = "_hu-0";